import { ORM } from "redux-orm";
import { Attachment } from "./attachment/attachment.model";
import { Chapter } from "./chapter/chapter.model";
import { Choice } from "./choice/choice.model";
import { Course, ScoresFactors } from "./course/course.model";
import { Discussion } from "./discussion/discussion.model";
import { ForumAttachment } from "./forum-attachment/forum-attachments.model";
import { Gateway } from "./gateway/gateway.model";
import { Invoice, InvoiceItem } from "./invoice/invoice.model";
import { Period } from "./period/period.model";
import { Program } from "./program/program.model";
import { Question } from "./question/question.model";
import { Quiz, QuizOverview } from "./quiz/quiz.model";
import { Post, Reply } from "./reply/reply.model";
import { Section } from "./section/section.model";
import { Teacher } from "./teacher/teacher.model";
import { Topic } from "./topic/topic.model";
import { PdfUnit, QuizUnit, VideoUnit, Unit } from "./unit/unit.model";
import { User, ForumUser } from "./user/user.model";
import { Event } from "./event/event.model";
import { Project, ProjectOverview } from "./project/project.model";
import { Chat, ChatMessage } from "./chat/chat.model";
import { LibraryDocument } from "./library-document/libraryDocument.model";
import { LibraryVideo } from "./library-video/libraryVideo.model";

const orm = new ORM();
orm.register(
    User,
    Chapter,
    Course,
    Program,
    Section,
    Teacher,
    Unit,
    Period,
    PdfUnit,
    VideoUnit,
    QuizUnit,
    Discussion,
    ForumUser,
    Post,
    Reply,
    Topic,
    Choice,
    Question,
    Quiz,
    Invoice,
    InvoiceItem,
    Gateway,
    Attachment,
    QuizOverview,
    ScoresFactors,
    ForumAttachment,
    Event,
    Project,
    ProjectOverview,
    Chat,
    ChatMessage,
    LibraryDocument,
    LibraryVideo
);

export default orm;
